import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca6292c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "child-component-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Without props", -1))
const _hoisted_3 = { class: "child-component-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "With props", -1))

import PropsChildComponent from '../components/PropsChildComponent.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(PropsChildComponent)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(PropsChildComponent, {
        "little-message": 'Hi, here come the props',
        "little-list": ['item1', 'item2', 'item3']
      })
    ])
  ], 64))
}
}

})